import React, { useState } from 'react';
import AuthWrapper from '../../components/Auth/AuthWrapper';
import ResetPassword from '../../components/Auth/ResetPassword';
import Background from '../../assets/bg.png';

export default () => {
    const [showPage, setShowPage] = useState(false);
    return (
        <div
            style={{
                minHeight: '100vh',
                height: 'auto',
                backgroundImage: `url(${Background})`,
                backgroundSize: 'cover',
            }}
        >
            <ResetPassword setShowPage={setShowPage} />
        </div>
    );
};
